export default __webpack_public_path__ + "static/media/Logo.a5cd95d9.png";